import React from 'react';
import { Box, Dialog, DialogContent, DialogTitle, Divider, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CollectionClientDetail, CollectionInvoiceDocument, CollectionInvoicePdf } from '../model';
import ClientInvoicesTable from './ClientInvoicesTable';

interface Props {
  open: boolean;
  onClose: () => void;
  company: string;
  documents: CollectionInvoiceDocument[];
  location: string;
  acctNo: string;
  clientId: number | null;
  onDueDateAdjusted?: (client: CollectionClientDetail) => void;
  onInvoicePdfUploaded?: (applyTo: string, pdf: CollectionInvoicePdf, acctNo: string) => void;
  onInvoicePdfDeleted?: (applyTo: string, pdfId: number, acctNo: string) => void;
}

const InvoicePdfsModal: React.FC<Props> = ({
  open,
  onClose,
  company,
  documents,
  location,
  acctNo,
  clientId,
  onDueDateAdjusted,
  onInvoicePdfUploaded,
  onInvoicePdfDeleted,
}) => {
  const matched = documents.filter((d) => d.has_pdf).length;
  const total = documents.length;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box>
          <Typography variant="h6">Invoices — {company}</Typography>
          <Typography variant="body2" color="textSecondary">
            {matched} of {total} {total === 1 ? 'invoice has a PDF' : 'invoices have PDFs'}
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ p: 0 }}>
        <ClientInvoicesTable
          documents={documents}
          location={location}
          acctNo={acctNo}
          company={company}
          clientId={clientId}
          onDueDateAdjusted={onDueDateAdjusted}
          noCard
          onUploaded={(applyTo, pdf) => onInvoicePdfUploaded?.(applyTo, pdf, acctNo)}
          onDeleted={(applyTo, pdfId) => onInvoicePdfDeleted?.(applyTo, pdfId, acctNo)}
        />
      </DialogContent>
    </Dialog>
  );
};

export default InvoicePdfsModal;
